export type CanvasAction =
  | 'duplicate'
  | 'rename'
  | 'move'
  | 'delete'
  | 'restore'
  | 'delete-permanent'
  | 'remove-from-project'

export type ContextMenuType = 'recents' | 'drafts' | 'trash' | 'project'

export const contextMenuConfigs: Record<ContextMenuType, CanvasAction[]> = {
  recents: ['duplicate', 'rename', 'move', 'delete'],
  drafts: ['duplicate', 'rename', 'move', 'delete'],
  trash: ['restore', 'delete-permanent'],
  project: ['duplicate', 'rename', 'move', 'remove-from-project', 'delete']
}

export const actionLabels: Record<CanvasAction, string> = {
  duplicate: 'Duplicate',
  rename: 'Rename',
  move: 'Move to...',
  delete: 'Delete',
  restore: 'Restore',
  'delete-permanent': 'Delete Forever',
  'remove-from-project': 'Remove from Project'
}

export const actionIcons: Record<CanvasAction, string> = {
  duplicate: 'copy',
  rename: 'edit',
  move: 'folder-open',
  delete: 'trash-2',
  restore: 'undo-2',
  'delete-permanent': 'trash-2',
  'remove-from-project': 'folder-minus'
}

export const actionShortcuts: Record<CanvasAction, string> = {
  duplicate: '⌘D',
  rename: 'F2',
  move: '',
  delete: '⌘⌫',
  restore: '',
  'delete-permanent': '⌘⇧⌫',
  'remove-from-project': ''
}

export const destructiveActions: CanvasAction[] = ['delete', 'delete-permanent', 'remove-from-project']